export default __webpack_public_path__ + "static/media/mahindra.708b4039.jpg";